
import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import Lapharian from "./pdf/lapharian";
import LapharianRekap from './pdf/lapharianRekap';

function LaporanJurnal() {
  const { baseURL } = useGlobalContext();
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [startDate, setStartDate] = useState(getTodayDate());
  const [endDate, setEndDate] = useState(getTodayDate());
  const [selectedPerkiraan, setSelectedPerkiraan] = useState("detail");
  const [loading, setLoading] = useState(false);

  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);
  const handlePerkiraanChange = (e) => setSelectedPerkiraan(e.target.value);

  // Handler untuk export Excel
  const handleExportExcel = async () => {
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan tanggal sampai.");
      return;
    }
    setLoading(true);
    try {
      const url = selectedPerkiraan === "rekap"
        ? `${baseURL}/api/exsportexcell/rekapjurnal/excel/${startDate}/${endDate}`
        : `${baseURL}/api/exsportexcell/jurnalharian/excel/${startDate}/${endDate}`;
      const response = await fetch(url, {
        credentials: "include",
        headers: {
          "Accept": "application/json",            
          "Content-Type": "application/json"
        }
      });
      if (!response.ok) {
        alert(`Gagal export Excel. Status: ${response.status}`);
        return;
      }
      const blob = await response.blob();
      const fileName = selectedPerkiraan === "rekap"
        ? `RekapJurnal_${startDate}_${endDate}.xlsx`
        : `JurnalHarian_${startDate}_${endDate}.xlsx`;
      // Download file
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert(`Terjadi kesalahan saat export: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan tanggal sampai.");
      return;
    }
  
    setLoading(true);
    try {
      const url = selectedPerkiraan === "rekap"
        ? `${baseURL}/api/akuntansi/rekapjurnal/${startDate}/${endDate}`
        : `${baseURL}/api/akuntansi/jurnalharian/${startDate}/${endDate}`;
  
      const response = await fetch(url, {
        credentials: "include",
        headers: {        
          "Accept": "application/json",            
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        alert(`Gagal mengambil data. Status: ${response.status}`);
        return;
      }
  
      const result = await response.json();
      const data = Array.isArray(result) ? result : result.data;
  
  
      if (!Array.isArray(data) || data.length === 0) {
        alert(`Data tidak ditemukan untuk periode ${startDate} - ${endDate}.`);
      } else {
        if (selectedPerkiraan === "rekap") {
          LapharianRekap(data, startDate, endDate);
        } else {
          Lapharian(data, data.length, 1, startDate, endDate);
        }
      }
    } catch (error) {
      alert(`Terjadi kesalahan: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-6">
            <div className="card card-info">
              <div className="card-header bg-info text-white">
                <h5 className="card-title mb-0">Laporan Harian Jurnal</h5>
              </div>
              <form className="form-horizontal p-3" onSubmit={(e) => e.preventDefault()}>
                <div className="form-group row">
                  <label htmlFor="tglmulai" className="col-sm-3 col-form-label">Tanggal</label>
                  <div className="col-sm-4">
                    <input
                      type="date"
                      className="form-control"
                      id="tglmulai"
                      name="tglmulai"
                      value={startDate}
                      onChange={handleStartDateChange}
                    />
                  </div>
                  <div className="col-auto d-flex align-items-center">
                    <span>s/d</span>
                  </div>
                  <div className="col-sm-4">
                    <input
                      type="date"
                      className="form-control"
                      id="tglsampai"
                      name="tglsampai"
                      value={endDate}
                      onChange={handleEndDateChange}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Jenis</label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      value={selectedPerkiraan}
                      onChange={handlePerkiraanChange}
                    >
                      <option value="rekap">Rekap</option>
                      <option value="detail">Detail</option>
                    </select>
                  </div>
                </div>

                <div className="form-group mt-4 text-right">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary mr-2"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Memproses..." : "Cetak Laporan"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={handleExportExcel}
                    disabled={loading}
                  >
                    {loading ? "Memproses..." : "Export Excel"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
        </div>
        
      </div>
        
    </div>
  );
}

export default LaporanJurnal;
